export const KBName = 'App';
export const KBNamePlural = 'Apps';